import { render, staticRenderFns } from "./BaseFormDragArea.vue?vue&type=template&id=216121e3&scoped=true"
import script from "./BaseFormDragArea.vue?vue&type=script&lang=js"
export * from "./BaseFormDragArea.vue?vue&type=script&lang=js"
import style0 from "./BaseFormDragArea.vue?vue&type=style&index=0&id=216121e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216121e3",
  null
  
)

export default component.exports